import { Component, Vue } from 'vue-property-decorator';
import { PendingsAop } from '~/lib/pendings-aop';
import HeroLoader from '../hero-loader';
import {andThen} from "~/lib/helpers";
import "./modal.scss";

@Component
export class SimpleModal extends Vue {

  protected pendings = {
    loading: new PendingsAop,
    commiting: new PendingsAop()
  };

  get isCommitable() {
    return true;
  }

  get modalClassNames() {
    return ["modal", "basic", "is-active"];
  }

  commit() {
    this.$emit("commit");
  }

  cancel() {
    this.$emit("cancel");
  }

  renderHead() {}

  renderBody() {
    return null;
  }

  renderFooter() {
    return [
      <button class="btn--link-grey" type="button" onClick={this.cancel}>
        Annuler
      </button>,
      <button class="button is-action-primary" type="button" onClick={this.commit} disabled={!this.isCommitable}>
        Créer
      </button>
    ];
  }

  render() {
    return (
      <div class={this.modalClassNames}>
        <div class="modal-background"></div>
        <div class="modal-card">

          {andThen(this.renderHead(), head => (
            <div class="modal-card-head">
              {head}
            </div>
          ))}

          <section class="modal-card-body">
            {this.renderBody()}
          </section>

          {andThen(this.renderFooter(), footer => (
            <footer class="modal-card-foot spaced">
              {footer}
            </footer>
          ))}

          {this.pendings.commiting.busy && <HeroLoader/>}

        </div>
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-f39be4b6/simple-modal.tsx" });